import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared';
import { Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
  template: ''
})

export class LogoutComponent implements OnInit {

  constructor(
    private router: Router,
    private userService: UserService,
    public toastr: ToastsManager
  ) {}

  ngOnInit() {
    var userType = window.localStorage["userType"] 
    let sessionInfo = {
          LogInLongitude: 11,
          LogInLatitude: 11,
          SessionId: window.localStorage['jwtToken'],
          LogInTime: new Date()
        }

    this.userService
    .logoutUserSession(sessionInfo)
     .subscribe(data => {
          this.userService
            .logoutSession()
             .subscribe(data => {
                     this.userService.purgeAuth();
                     this.router.navigate(['login']);
                 },
                  err => {
                  this.toastr.error(err);
                }
             );
         },
          err => {
          this.toastr.error(err);
        }
     );
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/logout.component.ts